export default {
  meau: {
    nav1: "모델",
    nav2: "채굴자",
    nav3: "학습",
    nav4: "크리에이터",
    nav5: "블로그",
    nav6: "아카데미",
    nav7: "도움말 센터",
    nav8: "HPVideo 사용 방법",
    nav9: "HPVideo로 이동",
    nav10: "x402 Skills"
  },
  home: {
    cont1: {
      title1: "HPVideo",
      title2: "BNB 체인 기반 탈중앙화 AI 비디오 제작 플랫폼",
      title3: "HPVideo는 BNB 체인 기반의 지갑형 탈중앙화 AI 비디오 제작 플랫폼으로, 다양한 AI 모델을 활용하여 빠르고 저렴한 비디오 제작 서비스를 제공합니다. 이메일 주소나 개인 정보는 필요하지 않습니다",
      text1: "10배 빠른 속도",
      text2: "비용",
      btn: "창작 시작하기",
      model1: {
        text: "특징 및 장점: 업계 표준으로 평가받는 모델로, 물리적 세계에 대한 깊은 이해와 시뮬레이션 능력을 자랑합니다. 복잡한 장면, 일관된 캐릭터, 다각도 카메라 전환이 포함된 영화 수준의 영상을 생성하며, 실제 물리 법칙을 따르는 움직임을 정밀하게 구현합니다.",
        tips: "예시: 거대한 털매머드가 안개 낀 북극의 숲에서 천천히 걸어나오는 영화 예고편 장면. 길게 늘어진 털이 자연스럽게 흔들리며, 석양빛 아래 입김이 하얗게 피어오르고, 카메라가 부드럽게 이동하며 영화적 긴장감을 연출합니다."
      },
      model2: {
        text: "특징 및 장점: 1분 이상의 고품질, 장면 일관성이 높은 장편 영상을 생성하는 데 특화되어 있습니다. 캐릭터와 스타일이 전체 영상 동안 일정하게 유지되며, 완성도 높은 짧은 서사 영상을 만들기에 적합합니다.",
        tips: "예시: 외로운 우주 비행사가 형형색색의 외계 행성에서 첫발을 내딛는 60초짜리 영상. 빛나는 이끼를 밟는 장면에서 시작해, 헬멧 속 감탄하는 표정의 클로즈업, 두 개의 달빛 아래 펼쳐진 환상적인 풍경까지 자연스럽게 전환됩니다."
      },
      model3: {
        text: "특징 및 장점: 고급 물리 엔진과 고품질, 고다이내믹 비디오 생성으로 유명합니다. 복잡한 물체 움직임, 유체(물, 연기 등) 시뮬레이션, 사실적인 빛-그림자 상호작용을 정교하게 표현합니다.",
        tips: "예시: 햇빛 아래 물풍선이 벽에 부딪히며 터지는 슬로모션 영상. 충돌 순간의 완벽한 구형 형태, 수천 개의 물방울이 반짝이며 퍼지는 장면, 벽에 반사되는 빛의 변화까지 섬세하게 포착합니다."
      },
      model4: {
        text: "특징 및 장점: 사실감과 역동성의 균형이 뛰어난 모델입니다. 캐릭터의 표정, 피부·천·금속 등의 질감, 환경 세부 묘사까지 정교하게 표현하면서 부드럽고 자연스러운 동작을 보여줍니다.",
        tips: "예시: 유리 공예 장인이 뜨거운 유리를 다루는 장면. 유리의 흐름, 붉은 빛의 열기, 도구의 질감, 장인의 집중된 표정까지 생생히 표현됩니다."
      },
      model5: {
        text: "특징 및 장점: 사용자 제어성이 높고 사실적인 디테일을 구현하는 통합형 AI 비디오 생성 툴입니다. 카메라 움직임, 캐릭터 일관성 등을 세밀하게 조정할 수 있으며, 자연스러운 인물 연기와 감정 표현을 담은 서사적 영상을 잘 만듭니다.",
        tips: "예시: 탐정이 어두운 도서관에서 먼지 쌓인 오래된 책을 여는 장면. 탐정의 신중한 표정, 빛줄기 속 먼지 입자, 책 속에 숨겨진 지도를 발견하는 순간이 극적으로 연출됩니다."
      },
      model6: {
        text: "특징 및 장점: 다양한 해상도의 영상을 생성할 수 있으며(세로 SNS 영상부터 영화 와이드스크린까지), 고품질 오디오와 영상의 완벽한 동기화를 지원하여 몰입감 있는 경험을 제공합니다.",
        tips: "예시: 사이버펑크풍의 9:16 세로 SNS 쇼트 영상. 네온 조명 아래 DJ가 루프탑에서 공연하며, 음악 비트에 맞춰 군중과 조명 효과가 완벽히 동기화됩니다."
      },
      model7: {
        text: "특징 및 장점: 대규모 동적 장면의 사실적 렌더링에 강점이 있습니다. 폭풍, 파도, 전투, 도시 교통 등 복잡한 움직임을 포함한 장면을 물리 기반 조명 효과로 사실적으로 구현합니다.",
        tips: "예시: 황혼의 중세 전쟁터를 비추는 항공샷. 수천 명의 병사, 화살이 쏟아지는 하늘, 연기 자욱한 불길, 바람에 휘날리는 깃발까지 영화 수준의 장면으로 연출됩니다."
      },
      model8: {
        text: "특징 및 장점: 다중 카메라 구도와 부드러운 전환을 특징으로 하는 모델입니다. 자동으로 클로즈업, 중경, 롱샷을 조합하여 짧은 광고나 스토리텔링 영상 제작에 적합합니다.",
        tips: "예시: 30초짜리 무성영화풍 영상. 낡은 편지가 우편함에 놓인 클로즈업 → 빗속에서 자전거를 타는 우편배달부의 중경 → 편지를 받고 미소 짓는 인물의 클로즈업으로 부드럽게 이어집니다."
      }
    },
    cont2: {
      title: "무엇을 도와드릴까요?",
      text1: "하얀 깃털 하나가 번개가 치는 먹구름 사이를 오르내리며 춤추다가, 폭풍의 소용돌이에 빨려 들어가 평온한 흔적을 남깁니다.",
      text2: "짙은 먹물이 맑은 물에 떨어져 천천히 퍼지며, 은하처럼 소용돌이치는 추상적인 심해가 잔잔한 유리잔 안에서 펼쳐집니다.",
      text3: "낡은 지도지로 접은 종이배가 비에 젖은 도시 하수로를 따라 네온사인 불빛을 비추며 흘러갑니다.",
      text4: "탁자 위에 놓인 종이학이 스스로 천천히 펼쳐지며, 한 장의 평평한 종이로 되돌아가면서 기억의 흔적을 남깁니다.",
      text5: "미래 도시의 반사가 고인 빗물에 비치고, 한 방울의 물이 떨어지자 물결이 퍼지며 도시의 영상이 찢어지고 재구성됩니다."
    },
    cont3: {
      title1: "탈중앙화된 지능 코어",
      text1_1: "분산 컴퓨팅",
      text1_2: "AI 심층 통합",
      text1_3: "신뢰 가능한 생성",
      text1_4: "효율적 창작",
      title2: "텍스트에서 움직이는 영상으로",
      text2_1: "텍스트 입력",
      text2_2: "프레임별 구성",
      text2_3: "영상 생성",
      text2_4: "고품질 출력",
      title3: "창작의 진정한 소유권",
      text3_1: "창작 타임스탬프",
      text3_2: "투명한 생성 과정",
      text3_3: "가치 보호",
      text3_4: "소유권 보장",
      title4: "오픈 콜래버레이션",
      text4_1: "전 세계 아이디어 연결",
      text4_2: "공유된 서사",
      text4_3: "협업 창작",
      text4_4: "혁신적인 이야기"
    },
    cont4: {
      title: "텍스트로 영상 만들기"
    },
    cont5: {
      title: "주요 사용 사례",
      text1: "영상 편집 및 변환",
      text2: "무드보드 제작",
      text3: "공간 시각 프리뷰",
      text4: "캐릭터 동작 캡처",
      text5: "가상 피팅",
      text6: "디자인 탐색",
      text7: "스토리보드 작성",
      text8: "애니메이션 프리비주얼",
      text9: "나를 생성하기",
      text10: "시각 효과 생성",
      text_cont1: {
        title: "영상 편집과 변환, 생성까지",
        text: "원하는 효과를 자연어로 설명하면 장면의 조명, 구도, 피사체 등을 자유롭게 바꿀 수 있어 복잡한 후편집 과정이 필요 없습니다."
      },
      text_cont2: {
        title: "감정이 담긴 무드보드 제작",
        text: "참고 이미지를 기반으로 동일한 스타일, 색감, 분위기의 영상과 이미지를 연속적으로 생성할 수 있습니다."
      },
      text_cont3: {
        title: "몇 초 만에 공간 연출 완성",
        text: "3D 모델링 없이 방 사진 한 장과 간단한 설명만으로 공간 배치를 시각적으로 완성할 수 있습니다."
      },
      text_cont4: {
        title: "누구나 할 수 있는 동작 캡처",
        text: "비싼 장비나 모션 캡처 촬영이 필요 없습니다. 카메라로 움직임을 녹화하면 원하는 캐릭터에 그대로 적용됩니다."
      },
      text_cont5: {
        title: "입어보고 싶은 옷 미리보기",
        text: "인물 사진 한 장과 의상 이미지만으로 다양한 착장을 시도할 수 있으며, 별도 합성 과정이 필요 없습니다."
      },
      text_cont6: {
        title: "이미지로 영감 얻기",
        text: "사진이나 텍스처에서 새로운 디자인이나 건축 아이디어를 탐색할 수 있습니다."
      },
      text_cont7: {
        title: "텍스트 프롬프트로 스토리보드 생성",
        text: "일관된 스타일을 유지하며, 텍스트만으로 빠르게 스토리보드를 구성할 수 있습니다."
      },
      text_cont8: {
        title: "스토리보드를 애니메이션으로",
        text: "이미지-비디오 변환 기능으로 저비용으로 고품질 프리비주얼 영상을 빠르게 제작할 수 있습니다."
      },
      text_cont9: {
        title: "다양한 스타일의 '나' 만들기",
        text: "셀피 한 장으로 다른 배경과 스타일의 새로운 이미지를 무한히 생성할 수 있습니다."
      },
      text_cont10: {
        title: "복잡한 시각 효과 생성",
        text: "Runway Aleph 모델을 통해 자연어로 원하는 시각 효과를 바로 생성할 수 있습니다."
      }
    },
    cont6: {
      title: "10배 속도, 10% 비용",
      cost_cont1: {
        title: "속도를 위한 설계",
        text1: "경량화된 모델 구조",
        text2: "대규모 병렬 연산",
        text3: "낮은 연산 비용",
        text4: "고처리량 파이프라인"
      },
      cost_cont2: {
        title: "하드웨어 가속",
        text1: "GPU 최적화 렌더링",
        text2: "AI 전용 하드웨어",
        text3: "효율적 메모리 관리",
        text4: "저지연 출력"
      },
      cost_cont3: {
        title: "10배 속도, 10% 비용",
        text1: "최적화된 모델 구조",
        text2: "분산 연산 효율",
        text3: "병렬 처리 파이프라인",
        text4: "하드웨어 가속 렌더링"
      },
      cost_cont4: {
        title: "가치는 극대화, 비용은 최소화",
        text1: "자원 활용 최적화",
        text2: "경제적 확장성",
        text3: "낮은 운영비용",
        text4: "최고의 효율성"
      }
    },
    cont7: {
      title1: "우리가 받은",
      title2: "지원과 인정"
    },
    cont8: {
      title: "우리 커뮤니티는 무한한 잠재력을 지닌 강력한 존재입니다"
    },
    model: {
      title: "HPVideo 지원 모델",
      learn_more: "자세히 보기",
      li1: {
        title: "Wan2.5",
        text1: "출시일: 2025년 9월 24일 (프리뷰 버전); ‘WAN 2.5 공식 버전’은 API 접근 및 공개 체험이 가능하며, 후속 버전의 공식 프리뷰 일정은 미정입니다.",
        text2: "개발사: 알리바바(중국) 톈이 연구소 (Alibaba Cloud Intelligence Group 산하 AI 연구 기관)."
      },
      li2: {
        title: "Ovi",
        text1: "출시일: 2025년 10월 15일 (공개 프리뷰); 오픈소스 버전은 2025년 10월 23일에 출시되었습니다 (2025년 11월 기준 'OVI 2' 공식 발표 없음).",
        text2: "개발사: Character AI (미국 기반 AI 연구소), 예일대학교 연구팀과 공동 개발."
      },
      li3: {
        title: "VEO 3.1",
        text1: "출시일: 2025년 8월 8일 (기업용 베타 접근); 공개 프리뷰는 2025년 11월 1일에 단계적으로 시작되었습니다 ('Veo4' 공식 발표는 아직 없습니다).",
        text2: "개발사: Google DeepMind (영국 기반 AI 연구소, Alphabet Inc. 산하)."
      },
      li4: {
        title: "LTX2 Pro",
        text1: "출시일: 2025년 7월 20일 (모바일 앱 독점 베타); 웹 기반 API는 2025년 10월 30일에 출시되었습니다 (2025년 11월 기준 ‘LTX-3’ 공식 일정 없음).",
        text2: "개발사: Lightricks (이스라엘 기반 AI 크리에이티브 툴 기업, Facetune/CapCut 경쟁사로 유명)."
      },
      li5: {
        title: "HAILUO 02",
        text1: "출시일: 2025년 9월 30일 (기업 파트너 대상 클로즈드 베타); 공개 API 및 웹 데모는 2025년 11월 10일에 출시되었습니다 (현재 ‘Hailuo-03’ 공식 로드맵 없음).",
        text2: "개발사: Minimax (중국 기반 AI 스타트업, 멀티모달 생성 및 엔터프라이즈 AI 솔루션 전문)."
      },
      li6: {
        title: "SEEDSNCE V1",
        text1: "출시일: 2025년 10월 12일 (ByteDance 생태계 내부 베타); 공개 REST API 및 TikTok Creator Studio 통합은 2025년 11월 20일에 출시되었습니다 (‘V2’ 공식 발표 없음).",
        text2: "개발사: ByteDance AI Lab (중국 기반 글로벌 기술 기업의 R&D 부문, 멀티모달 생성 및 숏폼 콘텐츠 툴 전문)."
      },
      li7: {
        title: "KLING V2.0",
        text1: "출시일: 2025년 11월 5일 (개발자 대상 공개 베타); 기업용 API 및 자체 호스팅 배포 옵션은 2025년 11월 22일에 출시되었습니다 (‘V3.0’ 공식 로드맵 없음).",
        text2: "개발사: Kwaivgi (싱가포르 기반 AI 스타트업, 글로벌 개발자 생태계를 위한 경량 멀티모달 생성 전문)."
      },
      li8: {
        title: "PIXVERSE V4.5",
        text1: "출시일: 2025년 9월 18일 (크리에이터 대상 공개 베타); 기업용 API 및 팀 협업 기능은 2025년 11월 15일에 추가되었습니다 (공식 ‘V5.0’ 로드맵은 2026년 1분기 4K 출력 중심으로 예정).",
        text2: "개발사: Pixverse AI (미국 기반 스타트업, 글로벌 R&D 팀 보유, 크리에이터 및 기업용 고품질 비주얼 생성 전문)."
      },
      li9: {
        title: "SORA (OpenAI)",
        text1: "출시일: 2024년 2월 (프리뷰 버전); ‘SORA 2’는 아직 공식 발표되지 않았으며, 후속 버전 관련 정보는 추측 단계입니다.",
        text2: "개발사: OpenAI (미국 기반 AI 연구소)."
      }
    }
  },
  models: {
    title: "HPVideo",
    text1: "HPVideo는 탈중앙화된 AI 비디오 생성 플랫폼으로, 분산 네트워크를 통해 강력하고 신뢰성 높은 창작 환경을 제공합니다. 사용자는 텍스트 프롬프트만 입력하면 프레임 단위로 구성된 고품질 영상을 손쉽게 생성할 수 있습니다. HPVideo는 타임스탬프 검증과 투명한 생성 과정을 통해 창작물의 진정한 소유권을 보장합니다.",
    text2: "또한 HPVideo는 전 세계 크리에이터들이 함께 협업할 수 있는 개방형 창작 환경을 지향하며, 커뮤니티 기반의 스토리 공유와 협업을 통해 새로운 창작 생태계를 만들어갑니다.",
    model1: {
      title: "Wan2.5",
      text1: "출시일: 2025년 9월 24일 (프리뷰 버전); WAN 2.5 정식 버전은 API 접속 및 공개 체험이 가능합니다 (후속 버전은 아직 미정).",
      text2: "개발사: Alibaba Tongyi Lab (알리바바 클라우드 산하 AI 연구소).",
      text3_1: "주요 기능:",
      text3_2: "텍스트 또는 이미지를 기반으로 사운드가 포함된 비디오를 생성 (음성, 효과음, 배경음악 포함), 길이는 최대 10초.",
      text3_3: "멀티모달 구조를 채택하여 물리 기반 시뮬레이션 및 카메라 움직임을 표현하며, 스토리텔링 연속성을 강화.",
      text3_4: "도시, 인물, 자연 등 다양한 주제의 비디오를 생성하며 이미지 편집 및 텍스트-이미지 변환도 지원.",
      text4: "출력: 480p–1080p 해상도(24fps)의 고품질 비디오, 시간 일관성과 텍스처 디테일이 뛰어나며 HDR 컬러링 지원."
    },
    model2: {
      title: "Ovi",
      text1: "출시일: 2025년 10월 15일 (공개 프리뷰); 10월 23일 오픈소스로 공개 (현재 OVI 2 버전은 미발표).",
      text2: "개발사: Character AI (미국 본사의 AI 연구소, 예일대 연구진과 공동 개발).",
      text3_1: "주요 기능:",
      text3_2: "텍스트 또는 텍스트+이미지를 입력해 5초 길이의 사운드 포함 비디오 생성, 자연스러운 움직임과 조명, 심도 효과를 구현.",
      text3_3: "110억 매개변수 중 50억이 오디오 브랜치에 사용되는 듀얼 백본 구조, 사실적인 물리 반응과 오디오-비디오 동기화 구현.",
      text3_4: "세로형(9:16), 가로형(16:9), 정사각형(1:1) 등 다양한 포맷 지원. 자체 호스팅도 가능.",
      text4: "출력: 720×720 (24fps) 기본 비디오, 프로 버전은 최대 1080p 지원, 인물 음성·효과음 동기화 탁월."
    },
    model3: {
      title: "VEO 3.1",
      text1: "출시일: 2025년 8월 8일 (기업용 테스트); 11월 1일부터 순차적으로 공개 프리뷰 시작.",
      text2: "개발사: Google DeepMind (영국 런던 소재, Alphabet 자회사).",
      text3_1: "주요 기능:",
      text3_2: "텍스트 프롬프트 기반으로 최대 15초 고해상도 비디오 생성, 세부 조정 가능한 프롬프트 반복 지원.",
      text3_3: "Gemini Ultra 2 멀티모달 모델을 기반으로 날씨, 천 질감 등 물리적 일관성을 유지하며 장면 간 공간 일체감 구현.",
      text3_4: "Google Workspace와 연동되어 Slides, Meet 등에서 바로 출력 가능, 영화/애니/실사 스타일 실시간 전환 지원.",
      text4: "출력: 1080p (30fps) HDR 비디오, 객체 디테일 우수, 환경 사운드 및 사용자 보이스오버 동기화."
    },
    model4: {
      title: "LTX2 Pro",
      text1: "출시일: 2025년 7월 20일 (모바일 독점 테스트); 10월 30일 웹 API 공개.",
      text2: "개발사: Lightricks (이스라엘 기반, Facetune 및 CapCut 경쟁사).",
      text3_1: "주요 기능:",
      text3_2: "텍스트 또는 이미지를 입력해 20초 내 8초 영상 생성, 모바일 환경에 최적화된 속도.",
      text3_3: "경량 20억 매개변수 모델, Reels/TikTok 트렌드 스타일, 필터, 스티커 포함.",
      text3_4: "인스타그램/TikTok 원클릭 업로드 지원, 저작권 음원 자동 동기화.",
      text4: "출력: 720p (30fps) SNS 최적화 영상, 색상 대비 강조, 짧은 오디오 자동 포함."
    },
    model5: {
      title: "HAILUO 02",
      text1: "출시일: 2025년 9월 30일 (파트너 대상 클로즈드 테스트); 11월 10일 API 및 웹 데모 공개.",
      text2: "개발사: Minimax (중국 AI 스타트업, 멀티모달 및 기업용 솔루션 전문).",
      text3_1: "주요 기능:",
      text3_2: "텍스트, 이미지 또는 혼합 입력으로 12초 고일관성 비디오 생성, 중국어 및 지역 문화 맥락 최적화.",
      text3_3: "클라우드-엣지 하이브리드 구조 (80억 매개변수), 단일 영상 추론 15초 이하, 커스텀 템플릿 지원.",
      text3_4: "도우인, 위챗 비디오 플랫폼 통합, 자동 자막(보통화·광둥어·영어) 및 합법적 음성 복제 기능.",
      text4: "출력: 1080p (24fps), 영화 수준 모션 블러 및 조명 효과, 배경음악·보이스오버 동기화 지원."
    },
    model6: {
      title: "SEEDSNCE V1",
      text1: "출시일: 2025년 10월 12일 (바이트댄스 생태계 내부 테스트); 11월 20일 TikTok Creator Studio 통합 API 공개.",
      text2: "개발사: ByteDance AI Lab (글로벌 멀티모달 연구 조직).",
      text3_1: "주요 기능:",
      text3_2: "텍스트 기반 10초 짧은 영상 생성, TikTok 트렌드(댄스, 제품 홍보 등)에 최적화.",
      text3_3: "40억 매개변수의 LightMultimodal 3.0 프레임워크 기반, 초고속 추론(12초 이하).",
      text3_4: "TikTok/도우인 원클릭 업로드, 해시태그 자동 추천, 글로벌 정책 준수.",
      text3_5: "기본 출력 480p, 내장 업스케일 API로 720p 업그레이드 가능.",
      text4: "출력: 480p (30fps, 9:16/16:9 지원), TikTok 색감 최적화, 인기 사운드·음악 포함."
    },
    model7: {
      title: "KLING V2.0",
      text1: "출시일: 2025년 11월 5일 (개발자 공개 테스트); 11월 22일 기업용 API 및 자가 호스팅 지원.",
      text2: "개발사: Kwaivgi (싱가포르 기반 AI 스타트업).",
      text3_1: "주요 기능:",
      text3_2: "텍스트·이미지·혼합 입력으로 14초 고해상도 영상 생성, 20개 이상 언어 프롬프트 지원.",
      text3_3: "모듈형 트랜스포머 구조 (60억 매개변수), 전자상거래·교육 등 수직 분야 맞춤형 튜닝 가능.",
      text3_4: "클라우드 REST API, 로컬 서버, 엣지 장치 등 다양한 배포 지원, GDPR/CCPA 준수.",
      text3_5: "프레임 단위 편집, 속도 제어, 오디오 교체 등 고급 편집 기능 제공.",
      text4: "출력: 1080p (24/30fps, 1:1/9:16/16:9 지원), 사실적 렌더링, MP4/WEBM/AV1 포맷 지원."
    },
    model8: {
      title: "PIXVERSE V4.5",
      text1: "출시일: 2025년 9월 18일 (크리에이터 공개 테스트); 11월 15일 기업용 협업 기능 추가.",
      text2: "개발사: Pixverse AI (미국 기반 글로벌 스타트업).",
      text3_1: "주요 기능:",
      text3_2: "텍스트·이미지·스토리보드 입력으로 16초 영화 수준 비디오 생성, 30종 이상의 스타일 프리셋 제공.",
      text3_3: "120억 매개변수 트랜스포머 기반, 시간 일관성 및 물리 기반 렌더링 강화.",
      text3_4: "한 번에 최대 50개 비디오 생성 가능, Adobe CC 및 Figma 플러그인 제공.",
      text3_5: "AI 자동 색보정, 모션 안정화, 자막 생성(40개국 언어 지원).",
      text4: "출력: 1080p (24/30/60fps, 1:1/9:16/21:9 지원), HDR 10bit, MP4/ProRes/AV1 지원."
    },
    model9: {
      title: "SORA (OpenAI)",
      text1: "출시일: 2024년 2월 (프리뷰 버전); SORA 2는 아직 발표되지 않음.",
      text2: "개발사: OpenAI (미국 본사 AI 연구소).",
      text3_1: "주요 기능:",
      text3_2: "텍스트 프롬프트를 기반으로 최대 60초 이상의 고사실적 비디오 생성.",
      text3_3: "물리 기반 시뮬레이션 및 장기 시퀀스 스토리텔링 지원.",
      text3_4: "도시, 인물, 자연 등 다양한 주제 커버.",
      text4: "출력: 최대 1080p 고화질 영상, 시간 일관성 및 디테일 우수."
    }
  },
  miners: {
    text1: "GPU 채굴에 참여하려면 NFT 노드가 필요합니다. 채굴 보상은 DEX 상장 후 약 3~6개월 뒤에 분배가 시작됩니다.",
    text2: "매년 50억 개의 HPC 토큰이 채굴 보상으로 배분됩니다. 10%는 즉시 지급되고, 나머지는 180일에 걸쳐 선형적으로 해제됩니다.",
    text3: "네트워크에 연결된 기계는 텍스트-비디오 요청을 완료할 때마다 HPC 보상을 받습니다. 단, 20블록(약 60초) 내에 결과를 생성하지 못하면 해당 요청은 무효 처리됩니다.",
    btn1: "HPC 구매",
    btn2: "Uniswap에서 HPC 거래",
    title: "채굴 장비 사양",
    title1: "GPU",
    text1_1: "Nvidia GPU 1개 이상 필요. GeForce 30/40 시리즈 권장. VRAM이 클수록 렌더링 속도와 수익이 향상됩니다.",
    title2: "메모리",
    text2_1: "최소 16GB 이상 권장",
    title3: "저장공간",
    text3_1: "최소 100GB 이상의 여유 디스크 공간 필요",
    title4: "네트워크",
    text4_1: "최소 5Mb 이상의 업로드 대역폭 권장"
  },
  learn: {
    title: "당신의 AI, 모든 것을 창작하다",
    text: "지속적으로 업데이트되는 튜토리얼, AMA, 심층 가이드를 통해 HPVideo를 쉽게 배워보세요. 초보자부터 전문가까지, 모든 크리에이터가 자신의 창작 흐름에 HPVideo를 통합할 수 있습니다.",
    text1: "카테고리",
    text2: "전체"
  },
  help: {
    title: "SORA 소개",
    text: "세상과 일관된 차세대 미디어 생성 AI 모델 시리즈.",
    btn1: "지금 체험하기",
    btn2: "문서 보기",
    title1: "창작에 필요한 모든 리소스",
    text1: "빠르게 시작할 수 있는 주제를 통해 HPVideo의 생성 및 AI 창작 도구 사용법을 배워보세요.",
    desc1: {
      title: "계정 및 결제",
      text: "구독 및 결제 정보를 관리하세요",
      btn1: "구독 관리",
      btn2: "계정 관리",
      btn3: "포인트 및 크레딧",
      btn4: "영수증"
    },
    desc2: {
      title: "HPVideo로 창작하기",
      text: "HPVideo의 기능과 워크플로우를 통해 프로젝트를 완성하는 방법을 배워보세요",
      btn1: "Gen-4",
      btn2: "워크플로우",
      btn3: "입문 가이드",
      btn4: "추가 도구"
    },
    desc3: {
      title: "엔터프라이즈",
      text: "기업 고객을 위한 계정 및 관리 리소스",
      btn1: "관리자 리소스",
      btn2: "팀원 리소스"
    },
    desc4: {
      title: "자산 및 작업공간",
      text: "파일 및 협업 공간을 효율적으로 구성하고 관리하세요",
      btn1: "자산 관리",
      btn2: "지원 파일 형식",
      btn3: "워크스페이스"
    },
    desc5: {
      title: "문제 해결",
      text: "기술적 오류 및 문제에 대한 솔루션을 찾아보세요",
      btn1: "구독 관리",
      btn2: "플랫폼 문제 해결",
      btn3: "기술 지원 요청"
    },
    desc6: {
      title: "커뮤니티, 프라이버시 및 콘텐츠 정책",
      text: "HPVideo 커뮤니티와 플랫폼 이용 및 콘텐츠 가이드라인을 확인하세요",
      btn1: "HPVideo 교육 프로그램",
      btn2: "커뮤니티",
      btn3: "신뢰와 안전"
    }
  },
  faqs: {
    title: "자주 묻는 질문",
    text: "FAQ",
    qs1: {
      title: "1. HPVideo란 무엇인가요?",
      text: "HPVideo는 BNB 체인 위에 구축된 탈중앙화 AI 텍스트-비디오 플랫폼으로, AI Agent 시대를 위한 미래형 영상 인프라를 목표로 합니다. 지갑을 연결하고 SORA, WAN, KLING 등의 모델을 선택한 뒤 프롬프트와 길이를 입력하고 소량의 USDT를 지불하면, 계정 등록 없이 고품질 영상을 생성할 수 있습니다."
    },
    qs2: {
      title: "2. HPVideo는 어떻게 영상을 생성하나요?",
      text: "HPVideo는 탈중앙화된 분산 연산을 통해 영상 생성 요청을 처리합니다. 사용자는 텍스트만 입력하면 되고, 모든 요청은 BNB 체인에 기록되어 투명성과 신뢰성을 보장합니다."
    },
    qs3: {
      title: "3. 왜 지갑 로그인 방식을 사용하나요?",
      text: "HPVideo는 이메일이나 중앙화 계정을 요구하지 않습니다. 지갑 로그인은 개인정보 보호와 보안성을 높이고, Web2와 Web3 사용자 모두 쉽게 접근할 수 있도록 합니다."
    },
    qs4: {
      title: "4. HPVideo는 어떻게 탈중앙화를 실현하나요?",
      text: "모든 요청, 결제, 타임스탬프가 BNB 체인에 기록되며, 분산된 노드가 영상을 생성합니다. 이로써 생성 과정의 투명성과 결과의 검증 가능성이 보장됩니다."
    },
    qs5: {
      title: "5. HPVideo는 어떤 AI 모델을 지원하나요?",
      text: "WAN 2.5, SORA, OVI, VEO 3.1, LTX2 Pro, KLING V2.0, PIXVERSE V4.5 등 다양한 모델을 지원하며, 각 모델은 특정 비주얼 스타일과 용도에 특화되어 있습니다."
    },
    qs6: {
      title: "6. 영상 생성 비용은 얼마인가요?",
      text: "모델과 영상 길이에 따라 다르며, 대부분 0.3~1 USDT 수준입니다. 결제는 BNB 체인 지갑을 통해 처리됩니다."
    },
    qs7: {
      title: "7. 생성된 영상의 소유권은 누구에게 있나요?",
      text: "모든 생성 결과물은 해당 지갑 주소의 소유가 됩니다. 블록체인 타임스탬프가 창작의 증거로 활용됩니다."
    },
    qs8: {
      title: "8. Web2 사용자도 HPVideo를 사용할 수 있나요?",
      text: "네. 지갑만 연결하면 프롬프트 입력 후 즉시 영상 생성이 가능합니다. 별도의 암호화폐 지식이 필요 없습니다."
    },
    qs9: {
      title: "9. HPVideo 토큰이 있나요?",
      text: "예. HPVideo는 $HPC 토큰을 발행하며, 거버넌스, 보상, 컴퓨팅 참여 및 생태계 유틸리티에 사용됩니다."
    },
    qs10: {
      title: "10. HPVideo의 장기 목표는 무엇인가요?",
      text: "HPVideo는 전 세계 크리에이터, AI Agent, Web3 앱을 위한 탈중앙화 영상 인프라 계층이 되는 것을 목표로 합니다. 투명한 생성 과정, 검증 가능한 소유권, 다중 모델 기반 창작 생태계를 제공합니다."
    }
  },
  footer: {
    title: "유용한 링크",
    meau1: "Github",
    meau2: "채굴자",
    meau3: "백서",
    meau4: "FAQ",
    meau5: "$HPC",
    title1: "HPVideo 시작하기",
    btn1: "HPVideo 체험하기",
    btn2: "데모 보기",
    footer_bottom: "2025 HPVideo. 모든 권리 보유."
  }
}